import "./chargeonCompare.scss";
import "../../src-utilities/header";
import "../../src-utilities/footer";
import Swiper from "./../../../node_modules/swiper";
import { Navigation, Autoplay, Pagination } from "swiper/modules";
import JustValidate from "just-validate";

// Chargeon Compare Header Script ------------------------------
const headerElem = document.querySelector(".chargeon-compare-header");
const headerToggle = document.querySelector(".chargeon-compare-header-toggle");
const headerDrawer = document.querySelector(
  ".chargeon-compare-header-mobile-drawer",
);
const mobileLinks = document.querySelectorAll(
  ".chargeon-compare-header-mobile-link, .chargeon-compare-header-mobile-cta",
);

if (headerElem) {
  const handleHeaderScroll = () => {
    if (window.scrollY > 20) {
      headerElem.classList.add("scrolled");
    } else {
      headerElem.classList.remove("scrolled");
    }
  };
  window.addEventListener("scroll", handleHeaderScroll);
  handleHeaderScroll();
}

if (headerToggle && headerDrawer) {
  headerToggle.addEventListener("click", () => {
    headerToggle.classList.toggle("active");
    headerDrawer.classList.toggle("active");
  });

  mobileLinks.forEach((link) => {
    link.addEventListener("click", () => {
      headerToggle.classList.remove("active");
      headerDrawer.classList.remove("active");
    });
  });
}
// Chargeon Compare Header Script ------------------------------

// Our Valued Customers Swiper Script ------------------------------
let swiperOptions = {
  modules: [Autoplay],
  slidesPerView: "auto",
  spaceBetween: 50,
  speed: 5000,
  freeMode: true,
  freeModeMomentum: false,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  },
  loop: true,
  breakpoints: {
    0: {
      slidesPerView: 3,
      spaceBetween: 15,
    },
    600: {
      slidesPerView: 5,
      spaceBetween: 50,
    },
    1024: {
      slidesPerView: 6,
      spaceBetween: 50,
    },
  },
};
new Swiper(".customers-logo", swiperOptions);
// Our Valued Customers Swiper Script ------------------------------

// What Makes ChargeOn Different Accordion Script ------------------------------
const initChargeonDifferentAccordion = () => {
  const accordionBoxes = document.querySelectorAll(
    ".chargeon-different-section .accordion-box",
  );
  const mainVideo = document.getElementById("chargeon-different-main-video");
  const mainSource = document.getElementById("chargeon-different-main-source");
  const mainImg = document.getElementById("chargeon-different-main-img");

  if (!accordionBoxes.length) return;

  // Auto-play initial video
  if (mainVideo) {
    mainVideo.play().catch(() => {});
  }

  accordionBoxes.forEach((box) => {
    const desc = box.querySelector(".accordion-description");

    if (box.classList.contains("active") && desc) {
      desc.style.maxHeight = desc.scrollHeight + "px";
    }

    box.addEventListener("click", (e) => {
      if (e.target.closest(".accordion-description")) {
        return;
      }

      const isActive = box.classList.contains("active");

      accordionBoxes.forEach((otherBox) => {
        if (otherBox !== box) {
          otherBox.classList.remove("active");
          const otherDesc = otherBox.querySelector(".accordion-description");
          if (otherDesc) {
            otherDesc.style.maxHeight = null;
          }
        }
      });

      if (isActive) {
        box.classList.remove("active");
        if (desc) {
          desc.style.maxHeight = null;
        }
      } else {
        box.classList.add("active");
        if (desc) {
          desc.style.maxHeight = desc.scrollHeight + "px";
        }

        // Dynamic media switching support (Video / WebM & Image)
        const mediaUrl = box.getAttribute("data-image");
        if (mediaUrl) {
          const isVideo =
            mediaUrl.endsWith(".webm") ||
            mediaUrl.endsWith(".mp4") ||
            mediaUrl.includes(".webm");

          if (isVideo && mainVideo && mainSource) {
            if (mainImg) mainImg.style.display = "none";
            mainVideo.style.display = "block";
            mainVideo.style.opacity = "0.4";

            setTimeout(() => {
              mainSource.src = mediaUrl;
              mainVideo.load();
              mainVideo.play().catch(() => {});
              mainVideo.style.opacity = "1";
            }, 150);
          } else if (mainImg) {
            if (mainVideo) mainVideo.style.display = "none";
            mainImg.style.display = "block";
            mainImg.style.opacity = "0.4";

            setTimeout(() => {
              mainImg.src = mediaUrl;
              mainImg.style.opacity = "1";
            }, 150);
          }
        }
      }
    });
  });
};
initChargeonDifferentAccordion();
// What Makes ChargeOn Different Accordion Script ------------------------------

// Chargeon Pricing Script ------------------------------
const showMoreBtn = document.getElementById("show-more-btn");
const planboxes = document.querySelectorAll(".plan-box");

let height = "150px";

if (window.innerWidth < 600) {
  height = "260px";
}

if (showMoreBtn) {
  showMoreBtn.addEventListener("click", (e) => {
    const planId = e.currentTarget.getAttribute("data-plan");
    const matched = Array.from(planboxes).find(
      (box) => box.getAttribute("data-plan-box-id") === planId,
    );
    if (!matched) return;

    const isActive = matched.classList.contains("active");

    planboxes.forEach((box) => {
      if (box !== matched) {
        box.classList.remove("active");
      }
    });

    if (isActive) {
      matched.style.height = matched.scrollHeight + "px";
      requestAnimationFrame(() => {
        matched.style.height = height;
        matched.classList.remove("active");
      });
    } else {
      matched.classList.add("active");
      const fullHeight = matched.scrollHeight + "px";
      matched.style.height = height;
      requestAnimationFrame(() => {
        matched.style.height = fullHeight;
      });

      matched.addEventListener(
        "transitionend",
        () => {
          if (matched.classList.contains("active")) {
            matched.style.height = "fit-content";
          }
        },
        { once: true },
      );
    }
  });
}
// Chargeon Pricing Script ------------------------------

// Our Offering Section Script ------------------------------
let headings = Array.from(
  document.querySelectorAll(".offering-headings .offering-heading"),
);

let parentContainer = document.querySelector(".offering-container");
let currentActive;

const swiper = new Swiper(".offering-details", {
  speed: 400,
  modules: [Autoplay],
  autoplay: {
    delay: 5000,
    pauseOnMouseEnter: true,
    waitForTransition: true,
  },
  breakpoints: {
    1050: {
      spaceBetween: 80,
    },
  },
  on: {
    init: function () {
      currentActive = headings[this.activeIndex];
      currentActive.classList.add("active-offering");
    },
  },
});

swiper.on("autoplayTimeLeft", function (a, b, percentage) {
  parentContainer.style.setProperty(
    "--active-width",
    `${100 - percentage * 100}%`,
  );
});

headings.forEach((element) => {
  element.addEventListener("click", (event) => {
    swiper.slideTo(event.target.dataset.id, 500);
  });
});

swiper.on("slideChange", function () {
  currentActive.classList.remove("active-offering");
  currentActive = headings[this.activeIndex];
  currentActive.classList.add("active-offering");
});
// Our Offering Section Script ------------------------------

// Customer Stories Slider ------------------------------
new Swiper(".swiper-container", {
  modules: [Pagination, Autoplay],
  slidesPerView: 1,
  loop: true,
  autoplay: {
    delay: 2000,
    pauseOnMouseEnter: true,
    disableOnInteraction: false,
  },
  breakpoints: {
    360: {
      slidesPerView: 1,
      spaceBetween: 35,
    },
    500: {
      slidesPerView: 1,
      spaceBetween: 35,
    },
    700: {
      slidesPerView: 2,
      spaceBetween: 35,
    },
    1200: {
      slidesPerView: 3,
      spaceBetween: 35,
    },
  },
  pagination: {
    el: ".swiper-container .swiper-pagination",
    clickable: true,
    dynamicBullets: true,
  },
});
// Customer Stories Slider ------------------------------

// Faq Script ------------------------------
const BindEvent = () => {
  let faq_question = document.getElementsByClassName("faq-question");
  let hiddenFaqs = document.querySelectorAll(".hidden-faq");
  let viewAllFaqBtn = document.querySelector(".faq-view-btn");

  for (let i = 0; i < faq_question.length; i++) {
    const question = faq_question[i];
    question.addEventListener("click", function (e) {
      let all_faq = document.getElementsByClassName("faq");
      let isopen = e.currentTarget.parentNode.classList.contains("active");
      for (let index = 0; index < all_faq.length; index++) {
        all_faq[index].classList.remove("active");
      }
      if (isopen == false) {
        e.currentTarget.parentNode.classList.add("active");
      }
    });
  }

  if (viewAllFaqBtn) {
    viewAllFaqBtn.addEventListener("click", () => {
      if (!viewAllFaqBtn.classList.contains("active")) {
        viewAllFaqBtn.textContent = "View Less";
        viewAllFaqBtn.classList.add("active");
        hiddenFaqs.forEach((hiddenFaq) => {
          hiddenFaq.style.display = "flex";
        });
      } else {
        viewAllFaqBtn.textContent = "View All";
        viewAllFaqBtn.classList.remove("active");
        hiddenFaqs.forEach((hiddenFaq) => {
          hiddenFaq.style.display = "none";
        });
      }
    });
  }
};
BindEvent();
// Faq Script ------------------------------

// Helper function to close all open modals
const closeAllCompareModals = () => {
  document
    .querySelectorAll(
      ".chargeon-compare-popup-screen, .modal-screen, #chargeonpop, .reserve-spot-popup-screen",
    )
    .forEach((modal) => {
      modal.classList.remove("open", "active");
      if (
        modal.id === "chargeonpop" ||
        modal.classList.contains("modal-screen")
      ) {
        modal.style.display = "none";
      }
    });
  document.body.style.overflow = "";
};

// Intercept trigger clicks in the capturing phase so theme scripts like footer.js never trigger #chargeonpop
window.addEventListener(
  "click",
  (e) => {
    const freeTrialTarget = e.target.closest(
      ".free-trial-open, a[href='#free-trial-modal']",
    );
    if (freeTrialTarget) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      closeAllCompareModals();
      const freeTrialModal = document.getElementById("free-trial-modal");
      if (freeTrialModal) {
        freeTrialModal.classList.add("open");
        document.body.style.overflow = "hidden";
      }
      return;
    }

    const demoTarget = e.target.closest(".demo-open, a[href='#demo-modal']");
    if (demoTarget) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      closeAllCompareModals();
      const demoModal = document.getElementById("demo-modal");
      if (demoModal) {
        demoModal.classList.add("open");
        document.body.style.overflow = "hidden";
      }
      return;
    }

    const featuresDeckTarget = e.target.closest(
      ".features-deck-open, a[href='#features-deck-modal']",
    );
    if (featuresDeckTarget) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      closeAllCompareModals();
      const featuresDeckModal = document.getElementById("features-deck-modal");
      if (featuresDeckModal) {
        featuresDeckModal.classList.add("open");
        document.body.style.overflow = "hidden";
      }
      return;
    }
  },
  true,
);

// region 1: Free Trial Popup Form JS
const initFreeTrialModal = () => {
  const freeTrialModal = document.getElementById("free-trial-modal");
  const freeTrialCloses = document.querySelectorAll(
    ".free-trial-close, #free-trial-modal .popup-close-btn",
  );

  if (!freeTrialModal) return;

  // Close Free Trial Modal
  freeTrialCloses.forEach((closeBtn) => {
    closeBtn.addEventListener("click", (e) => {
      e.preventDefault();
      freeTrialModal.classList.remove("open");
      document.body.style.overflow = "";
    });
  });

  // Close on Backdrop Click
  freeTrialModal.addEventListener("click", (e) => {
    if (e.target === freeTrialModal) {
      freeTrialModal.classList.remove("open");
      document.body.style.overflow = "";
    }
  });

  // Form 1 Validation & Submission with JustValidate
  const freeTrialForm = document.getElementById("free-trial-popup-form");
  if (freeTrialForm) {
    const validate_free_trial = new JustValidate("#free-trial-popup-form");

    validate_free_trial
      .addField("#free-trial-fullname", [
        { rule: "required" },
        { rule: "minLength", value: 2 },
        {
          rule: "customRegexp",
          value: /^(?=\S)([A-Za-z]+(?:\s+[A-Za-z]+){1,})$/,
          errorMessage: "Enter Valid Full Name",
        },
      ])
      .addField("#free-trial-email", [
        { rule: "required" },
        { rule: "email" },
        {
          validator: (value) => {
            let emailRegex =
              /^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
            return emailRegex.test(value);
          },
          errorMessage: "Please Enter Valid Email Address",
        },
      ])
      .addField("#free-trial-company", [
        { rule: "required" },
        { rule: "minLength", value: 2 },
        {
          rule: "customRegexp",
          value:
            /^(?=.*[a-zA-Z])[a-zA-Z0-9\-_.,;:?!(){}[\]<>@#$%^&*+=|\\\/\s]{1,120}$/,
          errorMessage: "Enter Valid Company Name",
        },
      ])
      .addField("#free-trial-phonecode", [
        {
          validator: (value) => value && value !== "Code",
          errorMessage: "Select Code",
        },
      ])
      .addField("#free-trial-phone", [
        { rule: "required" },
        { rule: "minLength", value: 7 },
        {
          rule: "customRegexp",
          value: /^[0-9\s\-()+]{7,15}$/,
          errorMessage: "Enter Valid Phone Number",
        },
      ]);

    validate_free_trial.onSuccess(async (event) => {
      if (event && event.preventDefault) event.preventDefault();
      const submitBtn = document.getElementById("free-trial-submit-btn");
      const formData = new FormData(freeTrialForm);
      const fullName = (formData.get("lfullname") || "").trim();
      const email = (formData.get("lemail") || "").trim();
      const company = (formData.get("lcompany") || "").trim();

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerText = "Submitting...";
      }

      let firstName, lastName;
      [firstName, ...lastName] = fullName.split(" ");
      lastName = lastName.join(" ");
      if (!lastName) lastName = firstName;

      const rawData = JSON.stringify({
        firstName: firstName,
        lastName: lastName,
        email: email,
        company: company,
        phone:
          (formData.get("phonecode") || "") +
          " " +
          (formData.get("lphone") || ""),
        leadSource: "chargeon-ads",
        websiteVisitURL: window.location.href,
      });

      try {
        await fetch(
          "https://us-west1-zoho-crm-scripts.cloudfunctions.net/queueLeadHttp",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: rawData,
          },
        );
      } catch (err) {
        console.error("Submission Error:", err);
      }

      window.location.href = "https://products.cyntexa.com/success/?form=trial";
    });
  }
};
initFreeTrialModal();
// endregion 1: Free Trial Popup Form JS

// region 2: Demo Popup Form JS
const initDemoModal = () => {
  const demoModal = document.getElementById("demo-modal");
  const demoCloses = document.querySelectorAll(
    ".demo-close, #demo-modal .popup-close-btn",
  );

  if (!demoModal) return;

  // Close Demo Modal
  demoCloses.forEach((closeBtn) => {
    closeBtn.addEventListener("click", (e) => {
      e.preventDefault();
      demoModal.classList.remove("open");
      document.body.style.overflow = "";
    });
  });

  // Close on Backdrop Click
  demoModal.addEventListener("click", (e) => {
    if (e.target === demoModal) {
      demoModal.classList.remove("open");
      document.body.style.overflow = "";
    }
  });

  // Form 2 Validation & Submission with JustValidate
  const demoForm = document.getElementById("demo-popup-form");
  if (demoForm) {
    const validate_demo = new JustValidate("#demo-popup-form");

    validate_demo
      .addField("#demo-fullname", [
        { rule: "required" },
        { rule: "minLength", value: 2 },
        {
          rule: "customRegexp",
          value: /^(?=\S)([A-Za-z]+(?:\s+[A-Za-z]+){1,})$/,
          errorMessage: "Enter Valid Full Name",
        },
      ])
      .addField("#demo-email", [
        { rule: "required" },
        { rule: "email" },
        {
          validator: (value) => {
            let emailRegex =
              /^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
            return emailRegex.test(value);
          },
          errorMessage: "Please Enter Valid Email Address",
        },
      ])
      .addField("#demo-company", [
        { rule: "required" },
        { rule: "minLength", value: 2 },
        {
          rule: "customRegexp",
          value:
            /^(?=.*[a-zA-Z])[a-zA-Z0-9\-_.,;:?!(){}[\]<>@#$%^&*+=|\\\/\s]{1,120}$/,
          errorMessage: "Enter Valid Company Name",
        },
      ])
      .addField("#demo-phonecode", [
        {
          validator: (value) => value && value !== "Code",
          errorMessage: "Select Code",
        },
      ])
      .addField("#demo-phone", [
        { rule: "required" },
        { rule: "minLength", value: 7 },
        {
          rule: "customRegexp",
          value: /^[0-9\s\-()+]{7,15}$/,
          errorMessage: "Enter Valid Phone Number",
        },
      ]);

    validate_demo.onSuccess(async (event) => {
      if (event && event.preventDefault) event.preventDefault();
      const submitBtn = document.getElementById("demo-submit-btn");
      const formData = new FormData(demoForm);
      const fullName = (formData.get("lfullname") || "").trim();
      const email = (formData.get("lemail") || "").trim();
      const company = (formData.get("lcompany") || "").trim();

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerText = "Submitting...";
      }

      let firstName, lastName;
      [firstName, ...lastName] = fullName.split(" ");
      lastName = lastName.join(" ");
      if (!lastName) lastName = firstName;

      const rawData = JSON.stringify({
        firstName: firstName,
        lastName: lastName,
        email: email,
        company: company,
        phone:
          (formData.get("phonecode") || "") +
          " " +
          (formData.get("lphone") || ""),
        leadSource: "chargeon-ads",
        websiteVisitURL: window.location.href,
      });

      try {
        await fetch(
          "https://us-west1-zoho-crm-scripts.cloudfunctions.net/queueLeadHttp",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: rawData,
          },
        );
      } catch (err) {
        console.error("Submission Error:", err);
      }

      window.location.href = "https://products.cyntexa.com/success/?form=demo";
    });
  }
};
initDemoModal();
// endregion 2: Demo Popup Form JS

// region 3: Features Deck Popup Form JS
const initFeaturesDeckModal = () => {
  const featuresDeckModal = document.getElementById("features-deck-modal");
  const featuresDeckCloses = document.querySelectorAll(
    ".features-deck-close, #features-deck-modal .popup-close-btn",
  );

  if (!featuresDeckModal) return;

  // Close Features Deck Modal
  featuresDeckCloses.forEach((closeBtn) => {
    closeBtn.addEventListener("click", (e) => {
      e.preventDefault();
      featuresDeckModal.classList.remove("open");
      document.body.style.overflow = "";
    });
  });

  // Close on Backdrop Click
  featuresDeckModal.addEventListener("click", (e) => {
    if (e.target === featuresDeckModal) {
      featuresDeckModal.classList.remove("open");
      document.body.style.overflow = "";
    }
  });

  // Form 3 Validation & Submission with JustValidate
  const featuresDeckForm = document.getElementById("features-deck-popup-form");
  if (featuresDeckForm) {
    const validate_features_deck = new JustValidate(
      "#features-deck-popup-form",
    );

    validate_features_deck
      .addField("#features-deck-fullname", [
        { rule: "required" },
        { rule: "minLength", value: 2 },
        {
          rule: "customRegexp",
          value: /^(?=\S)([A-Za-z]+(?:\s+[A-Za-z]+){1,})$/,
          errorMessage: "Enter Valid Full Name",
        },
      ])
      .addField("#features-deck-email", [
        { rule: "required" },
        { rule: "email" },
        {
          validator: (value) => {
            let emailRegex =
              /^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/;
            return emailRegex.test(value);
          },
          errorMessage: "Please Enter Valid Email Address",
        },
      ]);

    validate_features_deck.onSuccess(async (event) => {
      if (event && event.preventDefault) event.preventDefault();
      const submitBtn = document.getElementById("features-deck-submit-btn");
      const formData = new FormData(featuresDeckForm);
      const fullName = (formData.get("lfullname") || "").trim();
      const email = (formData.get("lemail") || "").trim();

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerText = "Submitting...";
      }

      let firstName, lastName;
      [firstName, ...lastName] = fullName.split(" ");
      lastName = lastName.join(" ");
      if (!lastName) lastName = firstName;

      const rawData = JSON.stringify({
        firstName: firstName,
        lastName: lastName,
        email: email,
        leadSource: "chargeon-features-deck",
        websiteVisitURL: window.location.href,
      });

      try {
        await fetch(
          "https://us-west1-zoho-crm-scripts.cloudfunctions.net/queueLeadHttp",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: rawData,
          },
        );
      } catch (err) {
        console.error("Submission Error:", err);
      }

      window.location.href =
        "https://products.cyntexa.com/success/?form=chargeon-features-guide";
    });
  }
};
initFeaturesDeckModal();
// endregion 3: Features Deck Popup Form JS

// Close on Escape Key
window.addEventListener("keydown", (e) => {
  if (e.key === "Escape") {
    closeAllCompareModals();
  }
});
